<template>
  <div class="cooperation-visa-detail-list-container">
    <div class="visa-info-box" style="paddingTop:10px">
      <!-- <div class="visa-info-item">
                合同签约金额：80万
            </div> -->
      <div class="visa-info-item" style="width:100%">
        申报日期：{{
          item.applydate && moment(item.applydate).format('YYYY-MM-DD')
        }}
      </div>
      <div class="visa-info-item">
        审核状态：<span style="color: #36C392">{{
          item && item.approvestate
        }}</span>
      </div>
      <div class="visa-info-item">
        确认状态：<span
          :style="{ color: item.qrstatus == '已确认' ? '#36C490' : '#C18858' }"
          >{{ item && item.qrstatus }}</span
        >
      </div>
    </div>
    <div class="text-box">
      <div class="visa-text-content">
        <span>变更名称：</span>
        <span>{{ item && item.altername }}</span>
      </div>
      <div class="visa-text-content">
        <span>变更单号：</span>
        <span>{{ item && item.altercode }}</span>
      </div>
      <div class="visa-text-content">
        <span>变更类型：</span>
        <span>{{ item && item.altertype }}</span>
      </div>
      <div class="visa-text-content">
        <span>变更原因：</span>
        <span>{{ item && item.alterreason }}</span>
      </div>
      <div class="visa-text-content">
        <span>变更原因说明：</span>
        <span>{{ item && item.alterreason1 }}</span>
      </div>
      <div class="visa-text-content">
        <span>变更内容：</span>
        <span>{{ item && item.altercontent }}</span>
      </div>
    </div>
    <div class="visa-text-money">
      <div>
        <span class="span_1">一单一估</span>
        <span>估算金额：</span>
        <span>{{ item && item.applyamountBz | money2 }}</span>
      </div>
      <div v-if="item.qrstatus == '已确认'">
        <span class="span_1">一单一结</span>
        <span>申报金额：</span>
        <span>{{ item && item.budgetdocno | money2 }}</span>
        <span>确认金额：</span>
        <span>{{ item && item.qrapproveamountBz | money2 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'cooperation-visa-detail-list',

  data() {
    return {
      testData: [1, 2, 3, 4],
      moment
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},

  components: {},

  methods: {}
};
</script>

<style scoped lang="scss">
.cooperation-visa-detail-list-container {
  position: relative;
  z-index: 9;
  .visa-text-content {
    display: flex;

    span:nth-child(1) {
      min-width: 140px;
      line-height: 1.5;
      display: inline-block;
      color: #999;
    }
    span:nth-child(2) {
      flex: 1;
      line-height: 1.5;
      color: #666;
    }
  }
  padding-top: 20px;
  .visa-info-item {
    text-align: left;
    padding-left: 32px;
  }
  .text-box {
    padding: 20px;
  }
  .visa-text-money {
    padding: 28px 0px;
    padding-bottom: 20px;
    border-top: 1px solid #efefef;
    padding-left: 20px;
    color: #666;
    div:nth-child(1) {
      margin-bottom: 40px;
    }
    div:nth-child(2) {
      span:nth-child(4) {
        margin-left: 70px;
      }
    }
    .span_1 {
      width: 120px;
      display: inline-block;
      background: #efefef;
      height: 40px;
      color: #36c490;
      line-height: 40px;
      text-align: center;
      font-size: 24px;
      margin-right: 20px;
    }
  }
}
</style>
